import { Platform, Screen } from "quasar";

const getDeviceInfo = () => {
  let width = 0;
  let height = 0;
  if (Platform.is.dektop) {
    width = Screen.width;
    height = Screen.height;
  } else {
    width = window.innerWidth;
    height = window.innerHeight;
  }
  const deviceInfo = {
    viewport: {
      width: width,
      height: height,
    },
    userAgent: Platform.userAgent,
    platform: Platform.is,
  };
  return deviceInfo;
};

const breakpointRatio = 9 / 16;

const mobileOrDesktop = (uri, query = {}, baseUrl = "") => {
  let layout = "mobile";
  if (Platform.is.desktop) {
    layout = "desktop";
  } else {
    const screenRatio = window.innerWidth / window.innerHeight;
    if (screenRatio > breakpointRatio) {
      layout = "mobile"; // original value was desktop but we are forcing mobile now
    }
  }
  if (query?.force) {
    layout = query.force === "desktop" ? "desktop" : "mobile";
    delete query.force;
  }

  const queryString = Object.keys(query).map(k => `${k}=${query[k]}`).join("&");

  try {
    if (layout === "desktop") {
      // redirect desktop
      top.document.location = `${baseUrl}/desktop${uri}?${queryString}`;
    } else {
      // redirect mobile
      top.document.location = `${baseUrl ?? ""}${uri}?${queryString}`;
    }
  } catch (e) {
    document.location = `${baseUrl ?? ""}${uri}?${queryString}`;
  }
};

export const platformValidations = {
  desktop: {
    firefox: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(Gecko\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Firefox\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    chrome: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Chrome\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    safari: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Version\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    edge: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Chrome\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Edg\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
  },
  mobile: {
    firefox: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(Gecko\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Firefox\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    chrome: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)((Chrome\/\d+\.{0,1}\d+(\.{0,1}\d+)*)|(CriOS\/\d+\.{0,1}\d+(\.{0,1}\d+)*))(.*)(Mobile)(.*)(Safari\/\d+\.{0,1}\d*(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    safari: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Version\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Mobile\/[\dA-Z]+)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    edgeA: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Chrome\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Mobile)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(EdgA\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
    edgeiOS: (userAgent) =>
      /^(Mozilla\/\d+\.\d+(\.{0,1}\d+)*)(.*)(AppleWebKit\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Version\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(EdgiOS\/\d+\.{0,1}\d+(\.{0,1}\d+)*)(.*)(Mobile\/[\dA-Z]+)(.*)(Safari\/\d+\.{0,1}\d+(\.{0,1}\d+)*)$/.test(
        userAgent
      ),
  },
  isFirefox: () =>
    platformValidations.desktop.firefox(navigator.userAgent) ||
    platformValidations.mobile.firefox(navigator.userAgent),
  isChrome: () =>
    platformValidations.desktop.chrome(navigator.userAgent) ||
    platformValidations.mobile.chrome(navigator.userAgent),
  isSafari: () =>
    platformValidations.desktop.safari(navigator.userAgent) ||
    platformValidations.mobile.safari(navigator.userAgent),
  isEdge: () =>
    platformValidations.desktop.edge(navigator.userAgent) ||
    platformValidations.mobile.edgeA(navigator.userAgent) ||
    platformValidations.mobile.edgeiOS(navigator.userAgent),
};

const browserValidation = () => {
  switch (true) {
    case platformValidations.isChrome():
    case platformValidations.isFirefox():
    case platformValidations.isSafari():
    case platformValidations.isEdge():
      return false;
    default:
      return true;
  }
};

const screenValidation = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isMobile = Platform.is.mobile;
  if (!isMobile) {
    if (width < 280 || height < 520) {
      return "desktopSize";
    }
  } else {
    const screenRatio = width / height;
    if (isMobile && screenRatio > 1) {
      return "landscape";
    }
  }
  return null;
};

export default getDeviceInfo;
export { mobileOrDesktop };
export { breakpointRatio };
export { screenValidation };
export { browserValidation };
